import { equipmentFieldForDisplayTranslation } from "@/common/constants/equipmentFieldForDisplay.constant";
import { EquipmentData } from "@/features/cards/types/CardDetails.type";
import { Car } from "lucide-react";

export class EquipmentsTransformer {
  static optionsTransformer() {
    return (equipments: EquipmentData[]) => {
      return equipments.map((equipment) => {
        return {
          value: equipment.id,
          label: `${equipment[equipment.model?.category?.field_for_display as keyof EquipmentData] || equipment.license_plate || equipment.official_name} ${equipment.model ? `(${equipment.model?.display_name})` : ''}`,
          icon: <Car strokeWidth={1} size={20} />
        };
      });
    };
  }

  static errorsTransformer() {
    return (errors: Record<string, string[]>) => {
      return Object.entries(errors).map(([key, value]) => {
        if (key in equipmentFieldForDisplayTranslation) {
          key = equipmentFieldForDisplayTranslation[key as keyof typeof equipmentFieldForDisplayTranslation];

          return {
            ['_base']: `${key} ${value.join(', ')}`,
          };
        }

        return {
          [key]: value.join(', '),
        }
      });
    };
  }

  static quickSearchModelTransformer() {
    return (equipments: EquipmentData[]) => {
      return equipments.map((equipment) => ({
        route: `/companies/${equipment.company_id}/equipments/${equipment.id}`,
        items: [
          [equipment.license_plate ? 'Placa' : 'Nome', equipment.license_plate || equipment.official_name],
          ['Marca', equipment.model?.brand],
          ['Modelo', `${equipment.model?.display_name} ${equipment.model?.year}`],
        ],
      }));
    }
  }
}
